import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetClaimAuthorizedOrganisations = (claimId) =>
  axios.get(`${apiPaths.claimAuthorizationsBase}?claim_id=${claimId}`);

const onAddClaimAuthorizedOrganisations = (organizationsToAuthorize) =>
  axios.post(apiPaths.claimAuthorizationsBase, organizationsToAuthorize);

const onDeleteClaimAuthorizedOrganisations = (organizationsToDelete) =>
  axios.post(`${apiPaths.claimAuthorizationsBase}/delete-many`, organizationsToDelete);

export { onGetClaimAuthorizedOrganisations, onAddClaimAuthorizedOrganisations, onDeleteClaimAuthorizedOrganisations };
